import styled from "@emotion/styled";

import Button from "metabase/core/components/Button";
import { color } from "metabase/lib/colors";
import { space } from "metabase/styled-components/theme";

export const StyledDeleteButton = styled(Button)`
  padding: 0.25rem 0.5rem;
  height: 2rem;
  min-width: 2rem;
  font-size: 1rem;
  :hover {
    cursor: pointer;
    color: ${color("danger")};
    background-color: ${color("bg-medium")};
  }
  svg {
    vertical-align: middle;
  }
`;

StyledDeleteButton.defaultProps = {
  onlyIcon: true,
  iconSize: 16,
};

export const ModalMessage = styled.div`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button + button {
    margin-left: 1rem;
  }

  .action-spin {
    margin-left: ${space(1)};
  }
`;
